module.exports = __webpack_public_path__ + "img/1L8.10e89aa0.png";